import React from 'react'
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell
} from 'recharts'

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']

export default function MonthlyChart({ monthly, technology }) {
  if (!monthly || monthly.length !== 12) return null

  const data = MONTHS.map((m, i) => ({ month: m, mwh: Math.round(monthly[i]) }))
  const max  = Math.max(...data.map(d => d.mwh))
  const color = technology === 'wind' ? '#22d3ee' : '#fbbf24'

  return (
    <div className="card">
      <div className="card__title">Monthly Yield (MWh)</div>
      <div className="chart-wrap" style={{ height: 120 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
            <XAxis dataKey="month" tick={{ fontSize: 10, fill: '#8892a4' }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 10, fill: '#8892a4' }} axisLine={false} tickLine={false} />
            <Tooltip
              contentStyle={{
                background: '#1a1d27',
                border: '1px solid #2d3148',
                borderRadius: 6,
                fontSize: 12,
              }}
              formatter={v => [`${v.toLocaleString()} MWh`, '']}
              labelStyle={{ color: '#e2e8f0' }}
            />
            <Bar dataKey="mwh" radius={[3, 3, 0, 0]}>
              {data.map((d, i) => (
                <Cell key={i} fill={d.mwh === max ? color : 'rgba(255,255,255,.18)'} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}
